import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicGroup({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M9.72 8.77a3.8 3.8 0 003.3 0h.2A2.78 2.78 0 0116 11.54v.7c0 .64-.52 1.16-1.16 1.16h-5.5c.8 0 .87-.71.87-1.58v-.42c0-1.23-1.05-2.11-1.71-2.44.32-.12.66-.2 1.02-.2zm-6.74 0a3.8 3.8 0 003.3 0h.2a2.78 2.78 0 012.77 2.77v.7c0 .64-.52 1.16-1.15 1.16H1.16C.52 13.4 0 12.88 0 12.24v-.7a2.78 2.78 0 012.78-2.77zm8.4-6.17a2.7 2.7 0 110 5.4 2.7 2.7 0 010-5.4zm-6.75 0a2.7 2.7 0 110 5.4 2.7 2.7 0 010-5.4z" />
    </svg>
  );
}

SvgBasicGroup.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicGroup.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicGroup svgRef={ref} {...props} />);
export default ForwardRef;
